import React from 'react';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import CircularProgress from '@material-ui/core/CircularProgress';
import { IMaskInput } from 'react-imask';
import { isEmpty } from 'lodash';
import LzFormFieldBase from './_base';
import { lzDateAddYears, lzGetFormattedDate, lzMomentGetDaysInMonth, LZ_MONTH_FULL_NAMES } from '../../../../services/LzMoment';

class LzFormFieldInput extends React.Component {

    onChange(val) {
        const { name, onChange } = this.props;

        if (onChange) {
            onChange(name, val);
        }
    }

    getNonEmptyDayMonthValueParts() {
        const { value } = this.props;

        if (!value || '' === value || value.length < 10) {
            return ['2000', '01', '01'];
        }

        return value.split('-');
    }

    onDayMonthChangeMonth(val) {
        const { name, onChange } = this.props;

        if (val < 1 || val > 12) {
            onChange(name, '');
            return;
        }

        const parts = this.getNonEmptyDayMonthValueParts();

        onChange(name, parts[0] + '-' + (val < 10 ? '0' : '') + val + '-' + parts[2])
    }

    onDayMonthChangeDay(val) {
        const { name, onChange } = this.props;

        if (val < 1 || val > 31) {
            onChange(name, '');
            return;
        }

        const parts = this.getNonEmptyDayMonthValueParts();

        onChange(name, parts[0] + '-' + parts[1] + '-' + (val < 10 ? '0' : '') + val)
    }

    onMonthYearChangeMonth(val) {
        const { name, onChange } = this.props;

        const parts = this.getNonEmptyDayMonthValueParts();

        onChange(name, parts[0] + '-' + val + '-' + parts[2])
    }

    onMonthYearChangeYear(val) {
        const { name, onChange } = this.props;

        const parts = this.getNonEmptyDayMonthValueParts();

        onChange(name, val + '-' + parts[1] + '-' + parts[2])
    }

    render() {
        const { fluid, required, className, style, id, name, label, type,
            autoFocus, value, size, hintText, placeholder, noAutocomplete,
            disabled, icon, formErrors, unitLabel, variant, margin, noHint,
            labelShrinked, mask, startYear, endYear
        } = this.props;

        const theName = name ? name : '';
        const theId = id ? id : 'id_' + theName;
        const inputProps = this.props.inputProps || {};
        let theType = type ? type : 'text';
        if ('year' === type) {
            theType = 'number';
            inputProps.min = 1900;
            inputProps.max = 2099;
            inputProps.step = 1;
            inputProps.placeholder = 'YYYY';
        }

        if (unitLabel && unitLabel !== '') {
            inputProps.endAdornment = <InputAdornment position="end">{unitLabel}</InputAdornment>;
        }

        const autoComplete = noAutocomplete || 'password' === theType ? 'new-password' : 'on';

        const labelShrinkedEx = labelShrinked || 'date' === theType || 'time' === theType;

        const hasError = formErrors && formErrors[theName];

        if (typeof value === 'undefined') {
            return <CircularProgress />;
        }

        if ('monthyear' === theType) {
            const currYear = +lzGetFormattedDate('now', 'YYYY');
            const fromYear = +(startYear || currYear - 2);
            const toYear = +(endYear || currYear + 2);
            const yearValue = '' === value ? '0000' : (value.substring(0, 4));
            const monthValue = '' === value ? '00' : (value.substring(5, 7));

            console.log('monthyear', 'CY:', currYear, 'FY:', fromYear, 'TY:', toYear, 'YV:', yearValue, 'MV:', monthValue, 'V:', value, 'YVC:', '' === yearValue, 'MVC:', '' === monthValue);

            const styles = style || {};
            if (fluid) {
                styles.flexGrow = 1;
            }

            return (
                <LzFormFieldBase
                    labelShrink
                    id={theId}
                    fluid={fluid}
                    required={required}
                    icon={icon}
                    name={name}
                    label={label}
                    className="lz-date-monthyear"
                >

                    <div className={'lz-date-monthyear-wrapper-' + (fluid ? 'fluid' : 'inline')}>

                        <Select
                            className={'lz-select lz-date-monthyear-month ' + (className ? className : '')}
                            style={styles} value={monthValue}
                            onChange={(evt) => this.onMonthYearChangeMonth(evt.target.value)}
                        >
                            <MenuItem value={'00'} disabled>Month</MenuItem>
                            {LZ_MONTH_FULL_NAMES.map((monthName, dex) =>
                                <MenuItem key={'optm-' + dex} value={(dex > 9 ? '' : '0') + (dex + 1)}>{monthName}</MenuItem>
                            )}
                        </Select>

                        <Select
                            className={'lz-select lz-date-monthyear-year ' + (className ? className : '')}
                            style={styles} value={yearValue}
                            onChange={(evt) => this.onMonthYearChangeYear(evt.target.value)}
                        >
                            <MenuItem value={'0000'} disabled>Year</MenuItem>
                            {Array.from({ length: toYear - fromYear + 1 }, (_, i) => fromYear + i).map((year, dex) =>
                                <MenuItem key={'opty-' + dex} value={year}>{year}</MenuItem>
                            )}
                        </Select>

                    </div>

                </LzFormFieldBase>
            );
        }

        if ('daymonth' === theType) {
            // console.log('VALUE', value);
            const monthValue = '' === value ? 0 : +(value.substring(5, 7));
            const dayValue = '' === value ? 0 : +(value.substring(8, 10));
            const daysInMonth = !value || '' === value ? 0 : lzMomentGetDaysInMonth(value);

            const styles = style || {};
            if (fluid) {
                styles.flexGrow = 1;
            }

            // console.log('VALS', value, monthValue, dayValue, daysInMonth);

            return (
                <LzFormFieldBase
                    labelShrink
                    id={theId}
                    fluid={fluid}
                    required={required}
                    icon={icon}
                    name={name}
                    label={label}
                    className="lz-date-daymonth"
                >

                    <div className={'lz-date-daymonth-wrapper-' + (fluid ? 'fluid' : 'inline')}>

                        <Select
                            className={'lz-select lz-date-daymonth-month ' + (className ? className : '')}
                            style={styles}
                            placeholder={placeholder || ''}
                            value={monthValue}
                            onChange={(evt) => this.onDayMonthChangeMonth(+evt.target.value)}
                        >
                            <MenuItem value={0}>month</MenuItem>
                            {LZ_MONTH_FULL_NAMES.map((monthName, dex) =>
                                <MenuItem key={'optm-' + dex} value={dex + 1}>{monthName}</MenuItem>
                            )}
                        </Select>

                        <Select
                            className={'lz-select lz-date-daymonth-day ' + (className ? className : '')}
                            style={styles}
                            placeholder={placeholder || ''}
                            value={dayValue > daysInMonth ? daysInMonth : dayValue}
                            onChange={(evt) => this.onDayMonthChangeDay(+evt.target.value)}
                        >
                            <MenuItem value={0}>day</MenuItem>
                            {[...Array(daysInMonth)].map((val, dex) =>
                                <MenuItem key={'optm-' + dex} value={dex + 1}>{dex + 1}</MenuItem>
                            )}
                        </Select>

                    </div>

                </LzFormFieldBase>
            );
        }

        let inputPropsObj = null;
        if (mask) {
            // return <MaskedInput mask={mask} />;
            inputPropsObj = {
                inputComponent: IMaskInput,
                inputProps: {
                    mask: mask,
                    autofix: true,
                    lazy: false,
                    overwrite: true,
                    placeholderChar: '#',
                    onAccept: (value) => this.onChange(value),
                },
            };
        }

        return (
            <TextField
                fullWidth={fluid} required={required} disabled={disabled}
                id={theId} name={theName}
                type={theType}
                autoFocus={autoFocus}
                autoComplete={autoComplete}
                placeholder={placeholder || ''}
                label={label}
                helperText={noHint ? false : (hasError ? formErrors[theName] : hintText || placeholder || '')}
                value={value}
                inputProps={inputProps}
                variant={variant}
                margin={margin}
                className={'lz-input ' + (className ? className : '')}
                style={style || {}}
                size={size}
                onChange={(evt) => this.onChange(evt.target.value)}
                error={formErrors && formErrors[name]}
                InputLabelProps={labelShrinkedEx || !isEmpty(value) ? { shrink: true } : {}}
                onFocus={(evt) => evt.target.select()}
                InputProps={inputPropsObj}
            />
        );
    }

}

const mapStateToProps = (state) => {
    return {
        formErrors: state.commons.formErrors,
    }
};

export default connect(
    mapStateToProps
)(LzFormFieldInput);
